import React from "react";
import './NewRewardSection.css';
import Button from "@mui/material/Button";
import {ReactComponent as NCXQuestionmark} from '../../../images/ncx-questionmark.svg';
import { useTranslation } from "react-i18next";

function NewRewardsection(){
    const { t } =useTranslation(); 
    return(
        <div className="new__homE_rewar">
            <div className="container">
                <div className="sdss__cc row">
                    <div className="firsttv col">
                        <div className="rr">
                            <h2>{t("new__1")}</h2>
                            <p>{t("new__2")}</p>
                            <Button href="https://exchange.ncx.cx/register" target="blank" rel="noreferrer" className="sign_Up">{t("sign_up")}</Button>
                        </div>
                    </div>
                    <div className="secondff col">
                        <div className="ddf sect">
                            <div class="dfss_m claim">
                                <h3>2,000<span>NCXT</span></h3>
                                <div className="dfss_m12">
                                    <div className="gnnll__l">
                                        <h4>{t("sign_up_verify")}</h4>
                                        <p>{t("new__3")}</p>
                                    </div>
                                    <div className="btn__ncx">
                                        <Button href="https://exchange.ncx.cx/ieolist" target="_blank" rel="noreferrer">{t("new__4")}</Button>
                                        <NCXQuestionmark />
                                    </div>
                                </div>
                            </div>
                            <div class="dfss_m claim">
                                <h3>500<span>NCXT</span></h3>
                                <div className="dfss_m12">
                                    <div className="gnnll__l">
                                        <h4>{t("new__5")}</h4>
                                        <p>{t("new__6")}</p>
                                    </div>
                                    <div className="btn__ncx">
                                        <Button href="https://exchange.ncx.cx/ieolist" target="_blank" rel="noreferrer">{t("new__7")}</Button>
                                        <NCXQuestionmark />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewRewardsection;